import React from "react";
import { Help as HelpComponent } from "../components/help/Help";

const Help = () => {
  return <HelpComponent />;
};

export default Help;
